{
  "intro": "Что работает в проекте, сколько это стоит и что происходит прямо сейчас.",
  "regions": "Регионы",
  "serverTypes": "Типы серверов",
  "from": "Серверы от",
  "perMonth": "{{price}}/мес",
  "stepsTitle": "Первые шаги",
  "stepsLead": "Выполненные шаги отмечены галочкой.",
  "stepConnect": "Подключить проект",
  "stepConnectText": "CloudServer обращается к Hetzner по токену этого проекта.",
  "stepSecure": "Защитить учётную запись",
  "stepSecureText": "Добавьте passkey или приложение-аутентификатор к паролю.",
  "openSecurity": "Открыть вход и безопасность",
  "stepCatalogue": "Выбрать размер и регион",
  "stepCatalogueText": "Сравните типы серверов и цены по регионам, прежде чем что-то создавать.",
  "openCatalogue": "Открыть каталог",
  "stepKey": "Добавить SSH-ключ",
  "stepKeyText": "С ключом вы входите на серверы без пароля.",
  "stepServer": "Создать сервер",
  "stepServerText": "Выберите регион, образ и тип, посмотрите цену, создайте.",
  "done": "Выполнено",
  "todo": "Ещё не выполнено",
  "openSshKeys": "Открыть SSH-ключи",
  "createServer": "Создать сервер",
  "running": "Работают: {{count}}",
  "costTitle": "Расходы, оценка",
  "costLead": "Этот месяц по часам и максимум, во что обойдутся эти ресурсы за полный месяц, без НДС.",
  "costHint": "Серверы, публичные IPv4-адреса, резервные копии, диски и плавающие IP по месячным ценам провайдера. Трафик сверх включённого и снимки не учтены.",
  "costServers": "Серверы",
  "costIpv4": "Публичные IPv4",
  "costBackups": "Резервные копии",
  "costTotal": "Итого в месяц",
  "costUnpriced": "Не учтено, нет цены в каталоге: {{count}}",
  "activityTitle": "Действия",
  "activityLead": "Изменения, которые идут сейчас, и последние выполненные.",
  "activityEmpty": "Из CloudServer в этом проекте ещё ничего не меняли.",
  "kinds": {
    "ssh_key": {
      "create": "Добавлен SSH-ключ",
      "update": "Изменён SSH-ключ",
      "delete": "Удалён SSH-ключ"
    },
    "network": {
      "create": "Создана сеть",
      "update": "Изменена сеть",
      "delete": "Удалена сеть",
      "protection": "Изменена защита сети",
      "add_subnet": "Добавлена подсеть",
      "delete_subnet": "Удалена подсеть",
      "add_route": "Добавлен маршрут",
      "delete_route": "Удалён маршрут",
      "attach": "Сервер подключён к сети",
      "detach": "Сервер отключён от сети"
    },
    "firewall": {
      "create": "Создан файрвол",
      "update": "Изменён файрвол",
      "delete": "Удалён файрвол",
      "set_rules": "Сохранены правила файрвола",
      "apply": "Файрвол применён",
      "remove": "Файрвол снят"
    },
    "server": {
      "create": "Создание",
      "update": "Имя или метки",
      "delete": "Удаление",
      "power_on": "Включение",
      "shutdown": "Завершение работы",
      "power_off": "Выключение питания",
      "reboot": "Перезагрузка",
      "reset": "Сброс",
      "enable_rescue": "Включение режима восстановления",
      "disable_rescue": "Отключение режима восстановления",
      "reset_password": "Сброс пароля root",
      "rebuild": "Переустановка",
      "change_type": "Смена типа",
      "enable_backups": "Включение резервного копирования",
      "disable_backups": "Отключение резервного копирования",
      "create_snapshot": "Снимок",
      "change_protection": "Изменение защиты",
      "attach_iso": "Подключение ISO",
      "detach_iso": "Отключение ISO"
    },
    "image": {
      "update": "Изменена копия диска",
      "convert": "Резервная копия сохранена как снимок",
      "protection": "Изменена защита снимка",
      "delete": "Удалена копия диска"
    },
    "public_ip": {
      "create": "Создан IP-адрес",
      "update": "Изменён IP-адрес",
      "assign": "IP-адрес назначен серверу",
      "unassign": "IP-адрес снят с сервера",
      "reverse_dns": "Изменена обратная DNS-запись",
      "protection": "Изменена защита IP-адреса",
      "delete": "Удалён IP-адрес"
    },
    "volume": {
      "create": "Создан диск",
      "update": "Изменён диск",
      "delete": "Удалён диск",
      "attach": "Диск подключён к серверу",
      "detach": "Диск отключён от сервера",
      "resize": "Диск увеличен",
      "protection": "Изменена защита диска"
    },
    "floating_ip": {
      "create": "Создан плавающий IP",
      "update": "Изменён плавающий IP",
      "delete": "Удалён плавающий IP",
      "assign": "Плавающий IP направлен на сервер",
      "unassign": "Плавающий IP снят с сервера",
      "reverse_dns": "Изменён обратный DNS плавающего IP",
      "protection": "Изменена защита плавающего IP"
    },
    "placement_group": {
      "create": "Создана группа размещения",
      "update": "Изменена группа размещения",
      "delete": "Удалена группа размещения",
      "add_server": "Сервер добавлен в группу размещения",
      "remove_server": "Сервер убран из группы размещения"
    },
    "load_balancer": {
      "create": "Создан балансировщик",
      "update": "Изменён балансировщик",
      "delete": "Удалён балансировщик",
      "add_service": "Добавлен сервис балансировщика",
      "update_service": "Изменён сервис балансировщика",
      "delete_service": "Удалён сервис балансировщика",
      "add_target": "Добавлена цель балансировщика",
      "remove_target": "Убрана цель балансировщика",
      "change_type": "Сменён тип балансировщика",
      "change_algorithm": "Сменён алгоритм балансировщика",
      "attach_network": "Балансировщик подключён к сети",
      "detach_network": "Балансировщик отключён от сети",
      "public_interface": "Изменён публичный интерфейс балансировщика",
      "reverse_dns": "Изменён обратный DNS балансировщика",
      "protection": "Изменена защита балансировщика"
    },
    "certificate": {
      "create": "Добавлен сертификат",
      "update": "Изменён сертификат",
      "delete": "Удалён сертификат",
      "retry": "Повторён выпуск сертификата"
    }
  },
  "costVolumes": "Диски",
  "costFloatingIps": "Плавающие IP"
}
